import axios, { AxiosResponse } from 'axios';
import { tryGetErrorMessage } from '../../types/XSifterGeneralTypes';
import { IXSifterUser, IXSifterOAuthUrlResponse, IXSifterTokenResponse, IXSifterDiscoverTextSitesResponse } from '../../types/XSifterAppUser';

// export const LOGIN_URL = process.env.API_BASE + "/login";
export const GET_OAUTH_URL = process.env.XSIFTER_BACKEND + "/oauth";
export const TOKEN_EXCHANGE_URL = process.env.XSIFTER_BACKEND + "/oauth/token";
// export const RENEW_URL = process.env.API_BASE + "/login/renew";
export const XSIFTER_LOGIN_URL = process.env.XSIFTER_BACKEND + "/login";
export const ACK_URL = process.env.XSIFTER_BACKEND + "/ack";
export const XSIFTER_GET_USER_URLL = process.env.XSIFTER_BACKEND + "/user";
export const XSIFTER_DT_SITES_URL = process.env.XSIFTER_BACKEND + "/sites";

export default class AuthService {

    async getOAuthLoginUrl(redirectUrl: string, hostname: string): Promise<IXSifterOAuthUrlResponse> {
        return new Promise<IXSifterOAuthUrlResponse>((resolve, reject) => {
            axios.get(GET_OAUTH_URL, {
                params: { redirectUrl: redirectUrl, hostname: hostname },
                headers: { 'Content-Type': 'application/json' }
            })
            .then((response: AxiosResponse) => {
                resolve(response.data);
            }).catch((error: any) => {
                reject(tryGetErrorMessage(error));
            });
        })
    }

    async exchangeCodeForToken(code: string, hostname: string): Promise<IXSifterTokenResponse> {
        return new Promise<IXSifterTokenResponse>((resolve, reject) => {
            axios.get(TOKEN_EXCHANGE_URL, {
                params: {
                    code: code,
                    hostname: hostname
                }
            }).then((response: AxiosResponse) => {
                resolve({
                    token: response.data.token,
                    expiresIn: response.data.expires_in
                });
            }).catch((error: any) => {
                reject(tryGetErrorMessage(error));
            });
        });
    }

    async loginToXSifter(token: string | null): Promise<IXSifterUser> {
        return new Promise<IXSifterUser>((resolve, reject) => {
            axios.get(XSIFTER_LOGIN_URL, {
                headers: { "Authorization": `Bearer ${token}` }
            })
            .then((response: AxiosResponse) => {
                resolve({
                    userId: response.data.userId,
                    lastLogin: response.data.lastLogin,
                    username: response.data.username,
                    fullName: response.data.fullName,
                    role: response.data.role,
                    hasAck: response.data.hasAck,
                    creditBalance: {
                        ledgerBalance: response.data.ledgerBalance,
                        availableBalance: response.data.availableBalance,
                        reservedCredits: response.data.reservedCredits
                    }
                })
            }).catch((error: any) => {
                reject(tryGetErrorMessage(error));
            });
        });
    }

    async getCurrentUser(token: string): Promise<IXSifterUser | undefined> {
        return new Promise<IXSifterUser | undefined>((resolve, reject) => {
            axios.get(XSIFTER_GET_USER_URLL, {
                headers: { "Authorization": `Bearer ${token}` }
            }).then((response) => {
                resolve(response.data);
            }).catch((error: any) => {
                reject(tryGetErrorMessage(error));
            });
        });
    }

    async refresh(apiBaseUrl: string, token: string): Promise<IXSifterTokenResponse> {
        return new Promise<IXSifterTokenResponse>((resolve, reject) => {
            let renewUrl = `${apiBaseUrl}/login/renew`;
            axios.get(renewUrl, {
                headers: { "Authorization": `Bearer ${token}` }
            })
            .then((response: AxiosResponse) => {
                resolve({
                    token: response.data,
                    expiresIn: undefined
                });
            }).catch((error: any) => {
                reject(tryGetErrorMessage(error));
            });
        });
    }

    async acknowledgeRules(token: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            axios.post(ACK_URL, null, {
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            })
            .then((response: AxiosResponse) => {
                resolve(true);
            }).catch((error: any) => {
                reject(tryGetErrorMessage(error));
            });
        });
    }

    public async getDiscoverTextSites(): Promise<IXSifterDiscoverTextSitesResponse> {
        return new Promise<IXSifterDiscoverTextSitesResponse>((resolve, reject) => {
            axios.get(XSIFTER_DT_SITES_URL)
                .then((response) => {
                    resolve(response.data);
            }).catch((error: any) => {
                reject(tryGetErrorMessage(error));
            });
        })
    }
};
